import { Component, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientService } from '../../services/client.service';
import { Clients } from '../../modal/clients';


@Component({
  selector: 'app-conferm-delete',
  templateUrl: './conferm-delete.component.html',
  styleUrls: ['./conferm-delete.component.scss']
})
export class ConfermDeleteComponent implements OnInit  {
  @Input() id:number=0
  @Output() confirmEvent = new EventEmitter<void>();
  constructor(private modalService: NgbModal,private _ClientService: ClientService,) {

   }

  ngOnInit(): void {
  }
  cancel(){
    this.modalService.dismissAll();
  }

  onConfirm(){
    this.confirmEvent.emit();
  }
}
